<ng-container *ngIf="showAccordion">
    <ppl-accordion [title]="'Service Credentials'" [isOpen]="true">
        <ng-container *ngTemplateOutlet="content">
        </ng-container>
    </ppl-accordion>
</ng-container>

<ng-container *ngIf="!showAccordion">
    <ng-container *ngTemplateOutlet="content">
    </ng-container>
</ng-container>

<ng-template #content>
    @if(mode==="edit"){
    <div class="ppl-mt24">
        <nz-card nz-col [nzSpan]="24" class="ppl-p24 ppl-step-main"
            [nzBordered]="false">
            <form nz-form [formGroup]="serviceCredentialsForm" class="ppl-p0">
                <nz-form-item nz-col nzSpan="12"
                    class="ppl-form-item nz-padding-left">
                    <nz-row>
                        <nz-form-label [nzSm]="10" [nzXs]="24"
                            nzFor="provider_lkp"
                            class="ppl-form-label">Participant
                            <span>*</span>
                        </nz-form-label>
                        <nz-form-control [nzSm]="12" [nzXs]="24"
                            class="ppl-form-control">
                            <div nz-tooltip
                                [nzTooltipTitle]="'Participant'"
                                nzTooltipPlacement="topRight">
                                <div
                                    [ngClass]="{'error': validationErrors['participant_lkp'] }">
                                    <ppl-dropdown-select
                                        formControlName="participantId"
                                        id="participantId"
                                        class="ppl-select"
                                        [options]="providerAssociations"
                                        [optionLabel]="'displayName'"
                                        [optionValue]="'participantId'"
                                        [showClearButton]="false"
                                        (selectionChange)="onParticipantChange($event)"
                                        [placeholder]="'Select Participant'">
                                    </ppl-dropdown-select>
                                </div>
                            </div>
                            @if (validationErrors['participant_lkp']) {
                            <span
                                class="pl-1 error-message">{{validationErrors['participant_lkp']}}</span>
                            }
                            <div
                                *ngIf="serviceCredentialsForm.get('participantId')?.errors?.['required'] && serviceCredentialsForm.get('participantId')?.touched"
                                class="pl-1 error-message">
                                Participant is required
                            </div>
                        </nz-form-control>
                    </nz-row>
                </nz-form-item>
                <nz-form-item class="ppl-form-item"
                    *ngIf="participantId && serviceCredentialsControls.controls.length > 0">
                    <nz-form-label [nzSm]="24" [nzXs]="24"
                        nzFor="serviceCredentials"
                        class="ppl-form-label"><span
                            id="serviceCredentials-label">
                            If you've been hired to provide any of the following
                            services, please check them off the list and provide
                            documentation of your credentials:
                        </span>
                    </nz-form-label>
                    <nz-form-control class="ppl-form-control">
                        <div formArrayName="services">
                            <ng-container
                                *ngFor="let credential of serviceCredentialsControls.controls; let i = index"
                                [formGroupName]="i">
                                <div class="credential-row">
                                    <nz-row nzAlign="middle">
                                        <nz-col nzSpan="20">
                                            <label nz-checkbox
                                                formControlName="checked"
                                                class="ppl-checkbox svc-checkbox">
                                                {{
                                                credential.get('serviceTypeName')?.value
                                                }}
                                            </label>
                                        </nz-col>
                                    </nz-row>
                                    <nz-row
                                        *ngIf="credential.get('checked')?.value"
                                        @slideInOut
                                        class="credential-details"
                                        nzGutter="16">
                                        <nz-col nzSpan="20" nzOffset="2">
                                            <nz-form-item>
                                                <nz-form-label
                                                    nzFor="licenseNumber"
                                                    nzSpan="8">Credential
                                                    Number</nz-form-label>
                                                <nz-form-control nzSpan="12"
                                                    nzErrorTip="Please enter a valid credential number!">
                                                    <input nz-input
                                                        formControlName="licenseNumber"
                                                        placeholder="Enter Credential Number"
                                                        maxlength="30" />
                                                </nz-form-control>
                                            </nz-form-item>
                                        </nz-col>
                                        <nz-col nzSpan="20" nzOffset="2">
                                            <nz-form-item>
                                                <nz-form-label nzSpan="8"
                                                    nzFor="expirationDate">Expiration
                                                    Date</nz-form-label>
                                                <nz-form-control nzSpan="12">
                                                    <ppl-date-picker
                                                        formControlName="expirationDate"
                                                        id="{{'expirationDate'+i}}"
                                                        [showIcon]="true"
                                                        [placeholder]="'Select Expiration Date'"
                                                        dateFormat="mm/dd/yy"
                                                        [readonlyInput]="false"
                                                        [monthNavigator]="true"
                                                        [yearNavigator]="true"
                                                        [yearRange]="'1900:2050'"
                                                        [iconDisplay]="'input'"
                                                        inputId="icondisplay"
                                                        [panelStyleClass]="'custom-calendar-panel'">
                                                    </ppl-date-picker>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </nz-col>
                                        <nz-col nzSpan="20" nzOffset="2">
                                            <nz-form-item>
                                                <nz-form-label nzSpan="8"
                                                    nzFor="documentation">Documentation
                                                    *</nz-form-label>
                                                <nz-form-control nzSpan="10">
                                                    <div
                                                        *ngIf="!isReadOnlyView && credential.get('files')?.value.length === 0">
                                                        <ppl-upload
                                                            [showFileList]="false"
                                                            [disableFileTypeSelection]="true"
                                                            [fileType]="'Service Credentials'"
                                                            [leadId]="providerId.toString()"
                                                            [showFileList]="true"
                                                            [fileList]="credential.get('files')?.value"
                                                            [consumerId]="participantId?.toString()"
                                                            [providerId]="providerId?.toString()"
                                                            [source]="'servicecredential'"
                                                            (fileSelected)="onFileSelected($event, credential)"
                                                            (fileRemoved)="onFileRemoved($event, credential)"
                                                            (downloadRequested)="onDownloadRequested($event)"
                                                            (uploadError)="onUploadError($event)"></ppl-upload>
                                                    </div>
                                                    <div
                                                        *ngIf="credential.get('checked')?.value && credential.get('files')?.value?.length === 0 && formSubmitRequested"
                                                        class="pl-1 error-message">
                                                        At least one document is
                                                        required
                                                    </div>
                                                    <div
                                                        *ngIf="credential.get('files')?.value.length > 0"
                                                        class="ppl-form-item">
                                                        <div
                                                            *ngFor="let file of credential.get('files')?.value; let i = index"
                                                            class="file-details">
                                                            <span
                                                                [title]="file.name"><span
                                                                    nz-icon
                                                                    nzType="paper-clip"
                                                                    nzTheme="outline"></span>{{
                                                                file.name |
                                                                slice:0:20
                                                                }}</span><span
                                                                *ngIf="file.name.length > 20">...</span>
                                                            <div
                                                                class="file-actions">
                                                                <ng-container>
                                                                    <button
                                                                        aria-label="Download"
                                                                        nz-button
                                                                        nzType="default"
                                                                        (click)="onDownloadRequested(file)"
                                                                        title="Download">
                                                                        <span
                                                                            nz-icon
                                                                            nzType="download"
                                                                            nzTheme="outline"></span>
                                                                    </button>
                                                                </ng-container>
                                                                <ng-container
                                                                    *ngIf="canEdit && !isReadOnlyView">
                                                                    <button
                                                                        aria-label="Delete"
                                                                        nz-button
                                                                        nzType="default"
                                                                        (click)="onFileRemoved(file.id, credential)"
                                                                        title="Delete">
                                                                        <span
                                                                            nz-icon
                                                                            nzType="delete"
                                                                            nzTheme="outline"></span>
                                                                    </button>
                                                                </ng-container>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </nz-col>
                                    </nz-row>
                                </div>
                            </ng-container>
                        </div>
                    </nz-form-control>
                </nz-form-item>
                <div
                    *ngIf="participantId && serviceCredentialsControls.controls.length === 0"
                    class="card">
                    <p-message severity="info">No service credentials available
                        for this participant.</p-message>
                </div>
            </form>
            <div class="custom-row">
                <ppl-button [label]="isReadOnlyView ? 'Close' : 'Cancel'" [icon]="'fa fa-close'"
                    style="margin-right:4px; font-size:0.857rem;"
                    [customClass]="'ghost-button'" [iconPosition]="'right'"
                    (click)="cancel()"></ppl-button>
                <ppl-button *ngIf="canEdit && !isReadOnlyView" label="Submit" icon="fa fa-check-circle"
                    [customClass]="'primary-button'" [iconPosition]="'right'"
                    (click)="saveCredentials()"></ppl-button>
            </div>
        </nz-card>
    </div>
    }
    @else if(mode==="read"){
    <div *ngIf="canEdit"
        class="ppl-mt16 btn-group d-flex flex-row btn-group justify-content-end"
        style="display: flex; gap: 8px;">
        <ppl-button [label]="'Edit'" icon="fa fa-plus"
            [customClass]="'alt-button'" [iconPosition]="'left'"
            (click)="onEditCredentialsClick()"></ppl-button>
    </div>

    <div class="ant-row">
        @if(serviceCredentials && serviceCredentials.length > 0) {
        <div class="ant-col-24">
            <p-table [value]="serviceCredentials" [responsiveLayout]="'scroll'">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of cols"
                            class="service-details-header">
                            {{ col.header }}
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowData
                    let-rowIndex="rowIndex"
                    let-col="cols">
                    <tr>
                        <td *ngFor="let col of cols">
                            @switch(col.field) {
                            @case('pplParticipantId') {
                            <div
                                style="white-space: nowrap;">{{rowData?.pplParticipantId}}</div>
                            }
                            @case('participantName') {
                            <div
                                style="white-space: nowrap;">{{rowData?.participantName}}</div>
                            }
                            @case('code') {
                            <ng-container
                                *ngFor="let credential of rowData?.credentials">
                                <div
                                    style="white-space: nowrap;">{{credential?.serviceDescription}}</div>
                            </ng-container>
                            }
                            @case('licenseNumber') {
                            <ng-container
                                *ngFor="let credential of rowData?.credentials">
                                <div style="white-space: nowrap;">
                                    {{credential?.licenseNumber || '-'}} </div>
                            </ng-container>
                            }
                            @case('expirationDate') {
                            <ng-container
                                *ngFor="let credential of rowData?.credentials">
                                <div style="white-space: nowrap;">
                                    {{credential?.expirationDate || '-'}} </div>
                            </ng-container>
                            }
                            @case('documentation') {
                            <ng-container
                                *ngFor="let credential of rowData?.credentials">
                                <div
                                    style="white-space: nowrap;">{{credential?.files}}</div>
                            </ng-container>
                            }
                            @case('actions') {
                            <div class="mobile-actions d-flex"
                                *ngIf="canView || canEdit"
                                style="gap: 4px;">
                                <!-- keep action icons compact for mobile -->
                                <ppl-button *ngIf="canView" label
                                    ariaLabel="View"
                                    (click)="onViewCredentials(rowData)"
                                    icon="fa fa-eye"
                                    [customClass]="'ghost-button'"></ppl-button>
                                <ppl-button *ngIf="canEdit" label
                                    ariaLabel="Edit"
                                    (click)="onEditCredentials(rowData)"
                                    icon="fa fa-pencil"
                                    [customClass]="'ghost-button'"></ppl-button>
                            </div>
                            }
                            }
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        }
        @else {
        <div class="ant-col-12 ppl-text-center ppl-mt24">
            <p-message severity="info">No Service Credentials Found.</p-message>
        </div>
        }
    </div>
    }
</ng-template>